import DataSelect from 'components/functional/misc/DataSelect';
import { architeckCall } from 'database';
import moment from 'moment';
import React from "react";
import { Helmet } from 'react-helmet';
import { connect } from 'react-redux';
import { Card, CardBody, CardHeader, Col, Container, Row } from "reactstrap";
import { toggleAlert } from 'store/functions/system';

class Profile extends React.Component {

    state = {
        payments: [],
        canSave: true
    }

    columns = [
        { 
            dataField: "project", 
            text: "Project", 
            sort: true, 
            formatter: (cell, row) => {
                return row.project.name
            },
            filterValue: (cell, row) => row.project.name
        },
        { 
            dataField: "company", 
            text: "Company", 
            sort: true, 
            formatter: (cell, row) => {
                return row.company.name
            },
            filterValue: (cell, row) => row.company.name

        },
        { 
            dataField: "description", 
            text: "Description", 
            sort: true, 
            formatter: (cell, row) => {
                return <span style={{wordBreak:' break-word', whiteSpace:' break-spaces'}}>{row.description}</span>
            },
            filterValue: (cell, row) => row.description

        },
        { 
            dataField: "amount", 
            text: "amount", 
            sort: true, 
            formatter: (cell, row) => {
                return <span>${(row.amount / 100 ).toFixed(2)}</span>
            }
        },
        { 
            dataField: "date", 
            text: "Date", 
            sort: true, 
            formatter: (cell, row) => {
                return moment.unix(row.date).format("MM/DD/YYYY")
            }
        },
       
        {
            dataField: "_id", 
            text: "Payment ID", 
            sort: true,
        },
    ]

    componentWillMount = async () => {

        if(!this.props.viewing_user) {
            return
        }

        const payments = await architeckCall({
            method: 'get',
            url: `/api/v1/payments/list?find_by=company__${this.props.viewing_user.company._id}&limit=500&loop=true`
        })

        if(payments.success) {

            this.setState({payments: payments.data})
 
        } else {

            toggleAlert(true, 'danger', `Something went wrong fetching project payments.`, 'infinite' )
            console.log(payments);

        }



    }
    
    render() {

        return (
            <>

            <Container>     

                <Helmet>
                    <title>Payments</title>
                    <meta name="description" content="Payments" />
                </Helmet>

                {this.state.alert}

              
                    <Card className="mt-4 bg-gradint-info">

                        <CardHeader className="bg-">
                            <h2 className="mb-0 ">Company Payments</h2>
                        </CardHeader>

                        <CardBody>
                            <Row>
                                <Col lg={2}>
                                    <img alt="..." className="w-100" src={require('assets/img/misc/Payments.svg')} />
                                </Col>
                                <Col lg={10}>
                                    <h4  className="mt-2 mt-lg-0">Transparent and simple.</h4>
                                    <p className="">At Architeck we do not believe in hiding the costs of development from anyone. We put great thought into designing this system with an emphasis on showing you exactly where your development budget is going. Below you can view every payment that your company has made across all the projects you have with us.</p>
                                </Col>
                            
                            </Row>

                        </CardBody>
                    </Card>

                <Card>
                    <CardHeader>
                        <h2 className="mb-0">All Paid Invoices</h2>
                    </CardHeader>
                    <CardBody className="pt-0">
                        <DataSelect 
                            modal={false}
                            data={this.state.payments}
                            btnClasses="btn btn-success btn-sm"
                            btnText="Select"
                            columns={this.columns}
                        />
                    </CardBody>
                </Card>

           

            </Container>
            </>
        );
    }
}



const mapStateToProps = state => {
    return {
  
      viewing_user: state.auth.viewing_user,
      app_users: state.users.app_users,
      app_projects: state.projects.app_projects,
  
    };
};
  
export default connect(mapStateToProps, '')(Profile);